export enum HtmlColor {
  Red = '#ff0000',
  Green = '#6fbd5e',
  Blue = '#307cff'
}
